import {
  Flex,
  FlexColumn,
  FlexSpace,
  DaysBackPicker,
  QuickFilters,
  FilterPopover,
  Breadcrumbs,
  GenerateAIButton,
} from '@elementary/common-ui/components';
import dayjs from 'dayjs';
import { ReactComponent as CriticalAssetIcon } from '@elementary/common-ui/assets/16x16/critical-asset-tag-color.svg';
import FilterChipRow from '@elementary/common-ui/components/Table/TableFilters/FilterChipRow';
import { useBreadcrumbs } from '@elementary/common-ui/hooks/useBreadcrumbs';
import useAccount from '@elementary/common-ui/hooks/useAccount';
import useDataHealthFilters from '../../hooks/useDataHealthFilters';

const Header = () => {
  const {
    urlFilters,
    filterOptions,
    updateFilter,
    addFilter,
    clearFilter,
    clearAllFilters,
    selectedDate,
    handleDaysBackChange,
    urlFiltersKey,
  } = useDataHealthFilters();

  const { data: account } = useAccount();

  const breadcrumbs = useBreadcrumbs({
    pageTitle: 'Data Health',
  });

  return (
    <>
      <FlexColumn gap={4}>
        <FlexSpace sx={{ alignItems: 'center' }}>
          <Breadcrumbs items={breadcrumbs} />
          {account?.ai_features_enabled && <GenerateAIButton />}
        </FlexSpace>

        <FlexColumn gap={1}>
          <Flex gap={1}>
            <FilterPopover
              filterOptions={filterOptions}
              onSubmit={(val) => {
                const newValue = (val.value || val.prevValue).filter(
                  (v) => v !== 'all',
                );

                if (val.prevValue?.length || val.prevValue?.includes('all')) {
                  updateFilter(
                    val.property,
                    val.operator,
                    val.prevValue.filter((v) => v !== 'all'),
                    newValue,
                  );
                } else {
                  addFilter(val.property, val.operator, newValue);
                }
              }}
              multiselect
            />

            <QuickFilters
              quickFilters={[
                {
                  name: 'Show only critical assets',
                  tooltip: 'Show only critical assets',
                  icon: <CriticalAssetIcon />,
                  filters: [
                    {
                      property: 'is_critical',
                      operator: 'equals',
                      value: ['true'],
                    },
                  ],
                },
              ]}
              urlParamsPrefix={urlFiltersKey}
            />

            <DaysBackPicker
              value={selectedDate}
              onChange={handleDaysBackChange}
              minDate={dayjs().subtract(9, 'day')}
              sx={{ marginLeft: 'auto' }}
            />
          </Flex>

          <FilterChipRow
            selectedFilters={urlFilters}
            filterOptions={filterOptions}
            clearFilter={clearFilter}
            onClearAll={clearAllFilters}
            onSubmit={(val) => {
              const newValue = (val.value || val.prevValue).filter(
                (v) => v !== 'all',
              );

              if (val.prevValue?.length || val.prevValue?.includes('all')) {
                updateFilter(
                  val.property,
                  val.operator,
                  val.prevValue.filter((v) => v !== 'all'),
                  newValue,
                );
              } else {
                addFilter(val.property, val.operator, newValue);
              }
            }}
          />
        </FlexColumn>
      </FlexColumn>
    </>
  );
};

export default Header;
